// extracted by mini-css-extract-plugin
module.exports = {"container":"comparePricesHeadCell_container__2D46p","title":"comparePricesHeadCell_title__2qBad","lineYellow":"comparePricesHeadCell_lineYellow__2jE-0","priceSection":"comparePricesHeadCell_priceSection__lAol6","dollar":"comparePricesHeadCell_dollar__13uxP","price":"comparePricesHeadCell_price__vb8LE","smallPrice":"comparePricesHeadCell_smallPrice__1u7ww","month":"comparePricesHeadCell_month__EFb1U","text":"comparePricesHeadCell_text__20SN5"};
    if(module.hot) {
      // 1745223430436
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  